/*
 * The version the footer shows. Read from package.json at build time so the number on
 * the screen is the number that was built; a hand-typed copy here sat at beta.39 for
 * weeks while the package moved on, which made "which build is prod running?" a
 * question nobody could answer from the phone.
 */
import { version } from '../../package.json'

export const APP_VERSION: string = version
export const APP_LABEL = `v${APP_VERSION}`
export const APP_BUILD = __BUILD_DATE__
